/**
 * Motivo da devolução.
 *
 * Empresas com REACT_APP_MOTIVO_DEVOLUCAO_TEXTO_LIVRE ligado pedem o motivo em
 * texto livre (campo motivo_devolucao_descricao) em vez de um item da lista, para
 * o motorista não escolher a opção errada. Nesse modo o código legado
 * (motivo_devolucao) continua indo como "1" e o texto é a fonte da verdade.
 */

export type ValoresMotivoDevolucao = {
  motivo_devolucao: string;
  motivo_devolucao_descricao?: string;
};

export const temMotivoDevolucaoEmTexto = (descricao?: string) =>
  String(descricao ?? "").trim() !== "";

export const motivoDevolucaoEmTexto = (descricao?: string) => String(descricao ?? "").trim();

export const erroDoMotivoDevolucao = (
  valores: ValoresMotivoDevolucao,
  motivoTextoLivre: boolean
): string | null => {
  if (motivoTextoLivre) {
    return temMotivoDevolucaoEmTexto(valores.motivo_devolucao_descricao)
      ? null
      : "Descreva o motivo da devolução.";
  }

  return parseInt(valores.motivo_devolucao) > 1 ? null : "Campo obrigatório";
};
